Ext.define('SA.lq.view.GeoUnitsCombo', {
    constructor(cmp) {
        this.cmp = cmp;
    },

    getValue() {
        return this.cmp.getValue();
    },

    setState(state) {
        var value = state.getSelectedGeoUnitId(),
            items = state.getSelectableGeoUnits().map(unit => ({value: unit.getId(), text: unit.getPluralName()}));

        this.cmp.setState({items, value});
    }
});